import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreCountriesModule,
  DatastoreUserRequiresGdprModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ResetPasswordModule } from 'app/login-signup/reset-password/reset-password.module';
import { SuccessRedirectModule } from '../success-redirect';
import { SignUpHeaderComponent, SignupComponent } from './signup.component';
import { SignupStepsModule } from './steps/signup-steps.module';

@NgModule({
  imports: [
    CommonModule,
    DatastoreCountriesModule,
    DatastoreUserRequiresGdprModule,
    PipesModule,
    ResetPasswordModule,
    SignupStepsModule,
    SuccessRedirectModule,
    TrackingModule,
    UiModule,
  ],
  exports: [SignupComponent, SignUpHeaderComponent],
  declarations: [SignupComponent, SignUpHeaderComponent],
})
export class SignupModule {}
